import {
  Component,
  ElementRef,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  VERSION,
} from "@angular/core";
import { MainService } from "../../services/main.service";
import { MapService } from "../../services/map.service";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { LocalDataSource } from "ng2-smart-table";
import { Map, View } from "ol";
import { Group, Vector as VectorLayer } from "ol/layer";
import { Style,Icon } from "ol/style";
import { transform } from "ol/proj";
import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import BingMaps from "ol/source/BingMaps";
import { Options } from 'ng5-slider';
import {getRenderPixel} from 'ol/render';
import { EcosistemasService } from "src/app/services/ecosistemas.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: "app-ecosistemas",
  templateUrl: "./ecosistemas.component.html",
  styleUrls: ["./ecosistemas.component.scss"],
})
export class EcosistemasComponent implements OnInit {
  mapReady = false;
  calPx = 3.779527559;
  serparadoComa: any;
  loadingPrincipal = false;
  @ViewChild("dialog", { static: true }) dialog: ElementRef;
  @ViewChild("infopanel", { static: false }) inform: ElementRef;
  @ViewChild("swipe", { static: false }) swipe: ElementRef;
  @Input() name: string;
  spinerEdit = false;
  
  /*****/
  activa1 = false;
  activa2 = false;
  empresa1 = false;
  coor: any[];
  coorPicado: any[];
  datos: any;
  datosAreas: any;
  datosAgua: any;
  vectorSource: any;
  vectorSource2: any;
  Nlayers: any[];
  datosTierra: any;
  activaTierra = true;
  activaAgua = false;
  activaAreas = false;
  cambiado = false;
  coberturas: any[] = [];
  cors=  '';// 'https://cors-anywhere.herokuapp.com/'
  cors2=  'https://cors-anywhere.herokuapp.com/';
  urlGeoserver = environment.geoserverBaseUrl;

  menu: any[] = [];
  urlActiva: any;
  opcionesA = false;
  opcionesB = false;
  actualizado = false;
  itemActivo = 0;
  empresaSeleccionada: any;
  tileL: any;
  capas: any[] = [];
  public source: LocalDataSource;
  mapId: string;
  public map: Map;
  s1: any;
  s2: any;
  toggle:boolean = true;
  toggle_leyenda:boolean = true;
  toggle_MapaBase:boolean = true;
  toggle_capa:boolean = true;
  toggle_medir:boolean = true;
  toggle_info:boolean = true;
  toggle_principal:boolean = true;
  toggle_AVC:boolean = true;
  toggle_florafauna:boolean = true;
  toggle_cambios_coberturas:boolean = true;
  toggle_menudesplegable:boolean = true;
  toggle_swipe:boolean = true;

  LayerBase = new TileLayer;
  LayersTematicos = new Group;
  value: number = 100;
  options: Options = {
    floor: 0,
    ceil: 100
  };
  public usuarioActivo: any;
  todas_empresas: any[];
  empresas_usuario: any[];
  empresas_nombre : any[];
  arr11 = [];
  arr12 = [];
  arr13 = [];
  arr14 = [];
  arr15 = [];
  empresas_checked = [];
  arrleyenda = [];
  public arrinfo = [];
  start_date: String;
  end_date: String;
  info_array: [];
  ZoomToJson;
  geojson;

  styleRecreacion = new Style({
    image: new Icon({
      anchor: [0.5, 46],
      src: '/assets/icons-png/Recreacion.png',
    })
  })

  basemap = [];
  
  capas_tematicas = []

  grupodelayers=[
    {name: 'Areas AVC HCS',id:'AVC', visible:false},
    {name: 'Registros de Fauna y Flora',id:'faunaflora',visible:false},
    {name: 'Cambios de Cobertura',id:'Cambios_Cobertura', visible:false}
  ]

  gfw= [
    {name:'gain',label:'Ganancia', url: '',value:'gain'},
    {name:'loss',label:'Perdida', url: '',value:'gain'},
  ]

  filtroGEP: any[];

  constructor(
    public router: Router,
    public mainService: MainService,
    public mapService: MapService,
    public ecosistemasService: EcosistemasService,
  ) {
    this.coberturas.push({
      posx: 0,
      posy: 60,
    });
    this.menu.push({
      posx: 0,
      posy: 80,
    });
    this.mainService.filtroGEP$.subscribe( variable => {
      this.filtroGEP = variable;
      if(this.map){
        this.checkEmpresa();
      }
    })
    this.ecosistemasService.capas_tematicas$.subscribe( variable => {
      this.capas_tematicas = variable
    })
    this.ecosistemasService.buttonStateChanged.subscribe((event: { buttonName: string, newState: boolean }) => {
      if (event.buttonName === 'toggle_swipe') {
        this.toggle_swipe = event.newState;
        document.getElementById("sel_swipe").style.display = this.toggle_swipe ? "none" : "block";
        console.log(document.getElementById("sel_swipe").style.display)
        this.SwipeUp()
      }
    })
  }

ngOnInit() {
  this.usuarioActivo = JSON.parse(localStorage.getItem('userOcelote'));
  this.basemap = this.mapService.getBaseLayers();
  this.ecosistemasService.updateCapasTematicas(this.mapService.LayerSelect)
  this.mapa(0);
}

SeleccionMapaBase(){
    this.toggle_MapaBase = !this.toggle_MapaBase;
}
checkEmpresa() {
  this.empresas_checked = this.filtroGEP['selectedEmpresas'].map(emp => emp.item_id);
  if(this.filtroGEP['selectedEmpresas'].length > 0){
    this.map.getLayers().forEach(lyr => {
      if(lyr  && lyr.get('name') != 'CapaBase'){
        if(this.empresas_checked.length > 0){
          lyr.get('source').updateParams({'cql_filter':'id_empresa IN ('+this.empresas_checked+')'});
          lyr.get('source').updateParams({"time": Date.now()});
        }else{
          this.map.removeLayer(lyr);
        } 
      }
    });
  }
}
checkModulo(event: any, id) { 
     if(id == 'AVC'){
        this.toggle_AVC = !this.toggle_AVC;
      }
      if(id == 'faunaflora'){
        this.toggle_florafauna = !this.toggle_florafauna;
      }
      if(id == 'Cambios_Cobertura'){
        this.toggle_cambios_coberturas = !this.toggle_cambios_coberturas;    
      } 
}

/*Herramienta de medida*/
mapa(id) {
      this.LayerBase = new TileLayer({
        visible: true,
        preload: Infinity,
        source: new BingMaps({
          key:
            "Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j",
          imagerySet: "AerialWithLabelsOnDemand",
        })
      })
      this.LayerBase.set('name', 'CapaBase');

      var view = new View({
        center: transform([-74, 4], 'EPSG:4326', 'EPSG:3857'),
        zoom: 5,
      });
      // se hace push al objeto layers, el cual ya contiene toda la informacion de las capas bing maps
      this.map = new Map({
        controls: [],
        layers:  [this.LayerBase],
        target: "map",
        view: view,
      });
      this.mainService.getFilterGep().subscribe( value => {
        this.filtroGEP = value
        setTimeout(()=>{
          this.checkEmpresa();
        }, 500)
      });
}


desplegarMenu(event, id){
  //this.toggle_menudesplegable = !this.toggle_menudesplegable;
  for(var i=0; i in this.capas_tematicas; i++){
    
    if(this.capas_tematicas[i].name == id){
        var name = this.capas_tematicas[i].name + "icon";
        if(document.getElementById(name).className == 'nb-close'){
          document.getElementById(this.capas_tematicas[i].value).style.display = 'none';
          document.getElementById(name).className = 'nb-plus'; 
        }else{
          document.getElementById(this.capas_tematicas[i].value).style.display = 'inline-flex'; 
          document.getElementById(name).className = 'nb-close'; 
        }
        
    }
  }
}

SwipeUp(){
  if(this.toggle_swipe == false){
    this.swipe.nativeElement.style.display = "block";

    const source_wms_satelital_antes = new TileWMS({
      url: 'http://52.41.100.219:8082/geoserver/bioap/wms?',
      params: {LAYERS: 'bioap:Pan_2013'},
      serverType: 'geoserver',
    });
    let satelital_antes = new TileLayer({
      visible: true,
      opacity: 1,
      source:  source_wms_satelital_antes,
    });

    satelital_antes.set('name', 'satelital_antes');
    this.map.addLayer(satelital_antes);

    const source_wms = new TileWMS({
      url: 'https://geoserver.mundialis.de/geoserver/gfc/wms?',
      params: {LAYERS: 'gfc:lossyear'},
      serverType: 'geoserver',
    });
    let deforestation = new TileLayer({
      visible: true,
      opacity: 1,
      source: source_wms,
    });

    deforestation.set('name', 'deforestacion');
    this.map.addLayer(deforestation);

    let mapa = this.map
    let swipeELemente = this.swipe.nativeElement

    deforestation.on('prerender', function (event) {
      const ctx = event.context;
      const mapSize = mapa.getSize();
      const width = mapSize[0] * (swipeELemente.value / 100);
      const tl = getRenderPixel(event, [width, 0]);
      const tr = getRenderPixel(event, [mapSize[0], 0]);
      const bl = getRenderPixel(event, [width, mapSize[1]]);
      const br = getRenderPixel(event, mapSize);
    
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(tl[0], tl[1]);
      ctx.lineTo(bl[0], bl[1]);
      ctx.lineTo(br[0], br[1]);
      ctx.lineTo(tr[0], tr[1]);
      ctx.closePath();
      ctx.clip();
    });

    deforestation.on('postrender', function (event) {
      const ctx = event.context;
      ctx.restore();
    });
    
    const listener = function () {
      mapa.render();
    };
    this.swipe.nativeElement.addEventListener('input', listener);
    this.swipe.nativeElement.addEventListener('change', listener);
  }else{
    this.map.getLayers().forEach(layer => {
      if (layer && layer.get('name') == "satelital_antes" ) {
        this.map.removeLayer(layer)
      }
    });
    this.map.getLayers().forEach(layer => {
      if (layer && layer.get('name') == "deforestacion" ) {
        this.map.removeLayer(layer)
      }
    });
    this.swipe.nativeElement.style.display = "none";
  }
}}